import { UAPPlacementTypeAlias as EPT } from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';
import { AdTypeEnum } from '@bingads-webui-campaign-react/image-experience-model';

const searchMMAConfig = {
  adType: AdTypeEnum.MMA,
  placementConfig: [{
    placementSetName: 'searchMMAConfig',
    placementTypes: [...EPT.MMA.All],
  }],
};

const msanMMAConfig = {
  adType: AdTypeEnum.MSAN,
  placementConfig: [{
    placementSetName: 'msanMMAConfig',
    placementTypes: [
      ...EPT.MSAN.All,
      EPT.Outlook.Web,
      EPT.Outlook.Mobile,
    ],
  }],
};

const msanMMAV2Config = {
  adType: AdTypeEnum.MSANV2,
  placementConfig: [{
    placementSetName: 'msanMMAV2Config',
    placementTypes: [
      ...EPT.MSANV2.All,
      EPT.Outlook.Web,
      EPT.Outlook.Mobile,
    ],
  }],
};

// Boost
const basicBoostPlacementTypes = [
  EPT.Boost.WindowsSpotlight,
  EPT.Boost.DiscoverCard,
  EPT.Boost.StartMenu,
  EPT.Boost.ActionCenter,
  EPT.Boost.Banner,
  EPT.Boost.Prong1Prong2Feed,
  EPT.Boost.Coachmark,
];
const msanMMABoostConfigBasic = {
  adType: AdTypeEnum.Boost,
  placementConfig: [{
    placementSetName: 'msanMMABoostConfigBasic',
    placementTypes: [
      ...EPT.MSAN.All, // MMA V2 is not supported in MSAN Boost
      ...basicBoostPlacementTypes,
    ],
  }],
};
const msanMMABoostConfigNew = {
  adType: AdTypeEnum.Boost,
  placementConfig: [{
    placementSetName: 'msanMMABoostConfigNew',
    placementTypes: [
      ...EPT.MSAN.All, // MMA V2 is not supported in MSAN Boost
      EPT.Boost.HeroImageCarousel200x100,
      ...basicBoostPlacementTypes,
    ],
  }],
};
const msanMMABoostConfigAll = {
  adType: AdTypeEnum.NewBoost,
  placementConfig: [{
    placementSetName: 'msanMMABoostConfigAll',
    placementTypes: [
      ...EPT.MSAN.All, // MMA V2 is not supported in MSAN Boost
      ...EPT.Boost.All,
    ],
  }],
};

const defaultConfig = {
  adType: 'default',
  placementConfig: [{
    placementSetName: 'defaultConfig',
    placementTypes: [
      EPT.Outlook.Web,
      EPT.Outlook.Mobile,
    ],
  }],
};

export const getUnifiedAdPreviewConfig = ({
  isMultimediaAd,
  isMultimediaAdinMSANEnabled,
  isMMAV2Enabled,
  isMSANBoostEnabled,
  isBoost200x100ImageEnabled,
  isBoostNewAspectRatioSupportEnabled,
}) => {
  if (isMultimediaAd) {
    return searchMMAConfig;
  }

  if (isMultimediaAdinMSANEnabled && !isMSANBoostEnabled && !isMMAV2Enabled) {
    return msanMMAConfig;
  }

  if (isMMAV2Enabled) {
    return msanMMAV2Config;
  }

  if (isMSANBoostEnabled) {
    if (isBoostNewAspectRatioSupportEnabled) {
      return msanMMABoostConfigAll;
    } else if (isBoost200x100ImageEnabled) {
      return msanMMABoostConfigNew;
    }
    return msanMMABoostConfigBasic;
  }

  return defaultConfig;
};
